import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "tenants",
  class: "tenants"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "pages" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_ArrowRight = _resolveComponent("ArrowRight")
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_Users = _resolveComponent("Users")
  const _component_UserStats = _resolveComponent("UserStats")
  const _component_Settings = _resolveComponent("Settings")
  const _component_Files = _resolveComponent("Files")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode(" Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "parent",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.onGoToTenants && $options.onGoToTenants(...args)))
              }, "Tenants"),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _createVNode(_component_ArrowRight, { class: "arrow" }),
              _createTextVNode(" " + _toDisplayString($data.tenant.name), 1 /* TEXT */)
            ])
          ]),
          _createVNode(_component_Tabs, {
            modelValue: $data.active_tab,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.active_tab) = $event)),
            tabs: $data.tabs,
            bordered: ""
          }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
          _createElementVNode("div", _hoisted_5, [
            ($data.active_tab === 'users')
              ? (_openBlock(), _createBlock(_component_Users, {
                  key: 0,
                  tenant: $data.tenant
                }, null, 8 /* PROPS */, ["tenant"]))
              : _createCommentVNode("v-if", true),
            ($data.active_tab === 'stats')
              ? (_openBlock(), _createBlock(_component_UserStats, {
                  key: 1,
                  api: $data.tenant.api_stats
                }, null, 8 /* PROPS */, ["api"]))
              : _createCommentVNode("v-if", true),
            ($data.active_tab === 'settings')
              ? (_openBlock(), _createBlock(_component_Settings, {
                  key: 2,
                  tenant: $data.tenant
                }, null, 8 /* PROPS */, ["tenant"]))
              : _createCommentVNode("v-if", true),
            ($data.active_tab === 'files')
              ? (_openBlock(), _createBlock(_component_Files, {
                  key: 3,
                  tenant: $data.tenant
                }, null, 8 /* PROPS */, ["tenant"]))
              : _createCommentVNode("v-if", true)
          ])
        ]))
  ]))
}